import { runtime } from '../../../../runtime/Runtime';
export class AppClockwork {
    parent;
    interval;
    constructor(parent, interval) {
        this.interval = interval;
        this.parent = parent;
    }
    get appClock() {
        return this.parent;
    }
    get runtimeClock() {
        return runtime.runtimeClock;
    }
    get tickingTime() {
        return (this.runtimeClock.getCustomClock(this.interval).tickingTime -
            this.appClock.appClockInternals.millisecondsDelayToRuntimeClock);
    }
}
